import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import './Nav.css';
import { LogOut } from 'lucide-react';

// Import your logo image here
import logo from './Assets/Logo.png'; // Replace with the correct path to your logo file

const getRandomDarkColor = () => {
  const calculateLuminance = (r, g, b) => {
    // Normalize RGB values to a scale of 0-1
    const a = [r, g, b].map((v) => {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
  };

  let color;
  let luminance;
  do {
    const letters = '0123456789ABCDEF';
    color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    // Convert hex to RGB
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);

    luminance = calculateLuminance(r, g, b);
  } while (luminance > 0.5); // Luminance threshold for dark colors

  return color;
};
const NavigationBar = ({ signOut, user, userData }) => { // Accept userData as a prop
  const [userAttributes, setUserAttributes] = useState({ email: '', username: '' });
  const navigate = useNavigate();

  useEffect(() => {

    if (userData) {
      // Extract username and email from userData
      const username = userData.name || 'No Username';
      const email = userData.email || 'No Email';
      setUserAttributes({ email, username });
    }

    const avatarColor = getRandomDarkColor();
    document.documentElement.style.setProperty('--avatar-color', avatarColor);
  }, [userData]);

  // Call the passed-down signOut prop function
  const handleSignOut = async () => {
    try {
      await signOut(); // This uses the signOut function passed down as a prop
      sessionStorage.clear();
      localStorage.clear();
      navigate('/', { replace: true });
    } catch (error) {
      console.error('Error signing out: ', error);
    }
  };

  const handleResetPassword = () => {
    const forgotPasswordUrl = `https://servqualit.auth.eu-west-1.amazoncognito.com/forgotPassword?client_id=37s0h2sugb7fb4d141qknsr1q4&response_type=token&scope=openid+email+profile&redirect_uri=https://support.servqualit.com/`;
    window.location.href = forgotPasswordUrl; // Redirects the user to Cognito Hosted UI
  };
  const capitalizeFirstLetter = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  return (
    <>
      <nav className="flex w-full px-2 py-2 navbar-dash">
        {/* Logo on the left side */}
        <Link to="/" className="navbar-brand">
          <img src={logo} alt="Logo" style={{ height: '38px' }} />
        </Link>
       
        <h3 className="heading-text-iam flex-grow">ServQual Customer Portal</h3>

        {/* Dropdown aligned to the right */}
        <div className="ml-auto mt-4 text-end drop">
          <Dropdown align="right">
            <Dropdown.Toggle id="user-dropdown" className="border-0 bg-transparent p-0 custom-toggle">
              <div className="flex items-center justify-center text-white bg-transparent mb-4">
                <span className="text-purple-600 font-bold text-lg avatar">
                  {userAttributes.username?.charAt(0).toUpperCase() || 'U'}
                </span>
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu className="dropdown-menu-right shadow-lg p-2">
              <div className="d-flex flex-row p-3">
                <span className="font-bold text-lg avatar">
                  {userAttributes.username?.charAt(0).toUpperCase() || 'U'}
                </span>
                <div className="d-flex flex-column navbar-icon">
                  <strong>
                    <span className="text-muted">
                      {capitalizeFirstLetter(userAttributes.username) || 'No Username'}
                    </span>
                  </strong>
                  <span className="text-muted">{userAttributes.email || 'No Email'}</span>
                </div>
              </div>
              <Dropdown.Divider />
               {/* Reset Password Link */}
               <Dropdown.Item
                as="button"
                className="d-flex align-items-center text-primary"
                onClick={handleResetPassword}
              >
                Reset Password
              </Dropdown.Item>
              <Dropdown.Item
                as="button"
                className="d-flex align-items-center text-danger"
                onClick={handleSignOut}
              >
                <LogOut className="me-2" />
                Log out
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </nav>
    </>
  );
};

export default NavigationBar;
